import React from "react";
import ReactModal from "react-modal";

import { color_black, color_grey_light, color_red_default, color_white } from "../../constants/colors";
import RadioBoxEmpty from "../controls/check-boxes/RadioBoxEmpty";
import { OnestNormalDefault, OnestNormalSmall, OnestSemiBoldSmall } from "../styled/TextComponents";
import { useWindowDimensions } from "../../utils";
import { useI18n } from "../../i18n/I18nProvider";

//import { styles } from "./Styles";

const ModalTimeZone = ({
    isOpen,
    onClose,
    userData,
    ipTimeZone,
    selectedTimeZone,
    setSelectedTimeZone,
    handleSaveTimeZone,
  
}) => {
    const {width: screenWidth} = useWindowDimensions();
    const { t } = useI18n();
    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={{
                content: {
                    backgroundColor: color_white,
                    borderRadius: "15px",
                    zIndex: 3001,
                    width: screenWidth > 520 ? "410px" : `${screenWidth - 120}px`,
                    height: screenWidth > 520 ? "min-content" : "min-content",
                    padding: "25px",
                    boxSizing: "border-box",
                    margin: "auto",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 0,
                    inset: screenWidth > 460 ? "40px" : `calc(50vw - ${screenWidth - 120 / 2}px)`
                },
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.65)",
                    backdropFilter: "blur(8px)",
                    overflow: "hidden",
                    zIndex: 3000,
                },
            }}
        >
            <h2 style={{
                fontFamily: "Onest",
                fontWeight: 500,
                fontSize: "24px",
                lineHeight: "120%",
                letterSpacing: "-3%",
                color: color_black,
                textAlign: "center",
                margin: 0,
                alignSelf: "stretch",
            }}>{t("Выберите часовой пояс")}</h2>
            <OnestNormalDefault
                style={{
                    textAlign: screenWidth > 520 ? "justify" : "center",
                    textAlignLast: "center",
                    textJustify: screenWidth > 520 ? "distribute" : undefined,
                    wordSpacing: screenWidth > 520 ? "-0.1em" : "normal",
                    lineHeight: "120%",
                    letterSpacing: "-3%",
                    margin: "10px 0 0 0",
                    width: screenWidth > 520 ? "353px" : "100%",
                    maxWidth: "353px",
                    alignSelf: "center",
                }}
            >
                {t("Ваше местоположение изменилось или у вас включён VPN. Пожалуйста, выберите часовой пояс, в котором вам удобнее видеть время на платформе")}
            </OnestNormalDefault>
              <div style={{ display: "flex", flexDirection: "column", gap: "16px", alignSelf: "flex-start", marginTop: "16px" }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <OnestSemiBoldSmall style={{
                        margin: "0 0 12px 0",
                        padding: 0,
                        lineHeight: "normal",
                        letterSpacing: "0%",
                        color: color_black
                    }}>
                        {t("Текущий")}
                    </OnestSemiBoldSmall>
                    <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: "8px",
                        margin: "0 0 0 -4px"
                    }}>
                        <RadioBoxEmpty
                            checked={selectedTimeZone === userData.time_zone}
                            onChange={() => setSelectedTimeZone(userData.time_zone)}
                        />
                        <OnestNormalSmall>
                            {userData.time_zone}
                        </OnestNormalSmall>
                    </label>
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <OnestSemiBoldSmall style={{
                        margin: "0 0 12px 0",
                        padding: 0,
                        lineHeight: "normal",
                        letterSpacing: "0%",
                        color: color_black
                    }}>
                        {t("Системный")}
                    </OnestSemiBoldSmall>
                    <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: "8px",
                        margin: "0 0 0 -4px"
                    }}>
                        <RadioBoxEmpty
                            checked={selectedTimeZone === Intl.DateTimeFormat().resolvedOptions().timeZone}
                            onChange={() => setSelectedTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone)}
                        />
                        <OnestNormalSmall>
                            {Intl.DateTimeFormat().resolvedOptions().timeZone}
                        </OnestNormalSmall>
                    </label>
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <OnestSemiBoldSmall style={{
                        margin: "0 0 12px 0",
                        padding: 0,
                        lineHeight: "normal",
                        letterSpacing: "0%",
                        color: color_black
                    }}>
                        {t("По местоположению")}
                    </OnestSemiBoldSmall>
                    <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: "8px",
                        margin: "0 0 0 -4px"
                    }}>
                        <RadioBoxEmpty
                            checked={selectedTimeZone === ipTimeZone}
                            onChange={() => setSelectedTimeZone(ipTimeZone)}
                        />
                        <OnestNormalSmall>
                            {ipTimeZone}
                        </OnestNormalSmall>
                    </label>
                </div>
            </div>     
            <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "15px",
                alignItems: "center",
                width: "100%",
                marginTop: "30px"
            }}>
                <button
                    disabled={!selectedTimeZone}
                    style={{
                        backgroundColor: selectedTimeZone ? color_red_default : color_grey_light,
                        color: color_white,
                        borderRadius: "15px",
                        border: "none",
                        padding: "10px 35px",
                        cursor: "pointer",
                        fontSize: "16px",
                        fontWeight: "400",
                        width: 224,
                        height: 40,
                        fontFamily: "Onest",
                        margin: 0,
                    }} onClick={handleSaveTimeZone}>{t("Сохранить")}</button>
                   
                <button
                    style={{
                        backgroundColor: color_white,
                        color: color_red_default,
                        borderRadius: "15px",
                        border: "1px solid " + color_red_default,
                        padding: "10px 35px",
                        cursor: "pointer",
                        fontSize: "16px",
                        fontWeight: "400",
                        width: 224,
                        height: 40,
                        margin: 0,
                    }}
                    onClick={onClose}>{t("Отмена")}</button>
            </div>
           
        </ReactModal>
    );
};

export default ModalTimeZone;